import { render, staticRenderFns } from "./registrateModal.vue?vue&type=template&id=a7fbc272&scoped=true"
import script from "./registrateModal.vue?vue&type=script&lang=js"
export * from "./registrateModal.vue?vue&type=script&lang=js"
import style0 from "./registrateModal.vue?vue&type=style&index=0&id=a7fbc272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fbc272",
  null
  
)

export default component.exports